import { graphql } from "gatsby"
import React, { useContext } from "react"

import Blocks from "@blocks/Blocks/Blocks"
import Layout from "@components/layout.js"
import SEO from "@components/seo"
import { SiteContext } from "@context/Provider"
import i18nWrapper from "@knowit-alma/common/src/lang/i18nWrapper"

const Page = (props) => {
  const {
    data: { single: page, relatedTaggedContent },
  } = props

  const {
    title,
    seo,
    uri,
    blocks,
    ancestors,
    language,
    translations,
    jwPlayerIDs,
  } = page

  const currentLanguage = language ? language.slug : "fi"

  // Context
  const context = useContext(SiteContext)
  context.relatedTaggedContent = relatedTaggedContent.edges
  context.currentLanguage = currentLanguage
  context.ancestors = ancestors
  context.title = title
  context.jwPlayerIDs = jwPlayerIDs

  // Preload the first or second image

  let preLoadImage = null
  const preLoadImageWidths = [480, 720, 1440, 1600]

  if (blocks && Array.isArray(blocks) && blocks.length > 1) {
    const firstBlock = blocks[0]

    if (firstBlock.__typename === "WpBlockAcfFrontPageHero") {
      preLoadImage = firstBlock?.blockDataFrontPageHero?.image
    }
    if (firstBlock.__typename === "WpBlockAcfHeroCombo5050") {
      preLoadImage = firstBlock?.blockDataHeroCombo?.image
    }
    if (firstBlock.__typename === "WpBlockAcfImageFullWidth") {
      preLoadImage = firstBlock?.blockDataImageFullWidth?.image
    }

    const secondBlock = blocks[1]

    if (secondBlock.__typename === "WpBlockAcfFrontPageHero") {
      preLoadImage = secondBlock?.blockDataFrontPageHero?.image
    }
    if (secondBlock.__typename === "WpBlockAcfHeroCombo5050") {
      preLoadImage = secondBlock?.blockDataHeroCombo?.image
    }
    if (secondBlock.__typename === "WpBlockAcfImageFullWidth") {
      preLoadImage = secondBlock?.blockDataImageFullWidth?.image
    }
  }

  return (
    <Layout
      translations={translations}
      currentLanguage={currentLanguage}
      lang={language.locale}
    >
      <SEO
        title={seo?.title}
        uri={uri}
        lang={language.locale}
        headJson={seo?.headJSON}
        translations={translations}
        preLoadImage={preLoadImage}
        preLoadImageWidths={preLoadImage ? preLoadImageWidths : null}
      />
      <Blocks blocks={blocks} />
    </Layout>
  )
}

export default i18nWrapper("Page")(Page)

export const query = graphql`
  query SINGLE_PAGE($id: String!, $customTagsArray: [String]) {
    relatedTaggedContent: allWpPost(
      filter: {
        customTags: { nodes: { elemMatch: { id: { in: $customTagsArray } } } }
      }
      sort: { date: DESC }
      limit: 3
    ) {
      edges {
        node {
          id
          title
          uri
          categories {
            nodes {
              name
            }
          }
          featuredImage {
            node {
              mediaDetails {
                width
                height
              }
              sourceUrl
            }
          }
        }
      }
    }
    single: wpPage(id: { eq: $id }) {
      title
      seo {
        title
        headJSON
      }
      uri
      language {
        slug
        locale
      }
      translations {
        title
        uri
        language {
          slug
          locale
        }
      }
      jwPlayerIDs
      #############
      blocks {
        ...BlocksFirstLevel
        ...Blocks
      }
      ancestors {
        nodes {
          uri
          ... on WpPage {
            title
          }
        }
      }
    }
  }
`
